import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../common/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { BannerComponent } from './banner/banner.component';
import { HowItWorkComponent } from './how-it-work/how-it-work.component';
import { TalyPartnersComponent } from './taly-partners/taly-partners.component';
import { HomeFaqComponent } from './home-faq/home-faq.component';
import { AppDetailsComponent } from './app-details/app-details.component';
import { TalyFeaturesComponent } from './taly-features/taly-features.component';
import { TalyBusinessComponent } from './taly-business/taly-business.component';
import { MobileTalyPartnersComponent } from './mobile-taly-partners/mobile-taly-partners.component';


@NgModule({
  declarations: [
    HomeComponent,
    BannerComponent,
    HowItWorkComponent,
    TalyPartnersComponent,
    HomeFaqComponent,
    AppDetailsComponent,
    TalyFeaturesComponent,
    TalyBusinessComponent,
    MobileTalyPartnersComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    TranslateModule.forChild(),
  ]
})
export class HomeModule { }
